import {$controller} from "rapid/index";

const dependencies = [];

export class passwordController extends $controller {

	constructor($injector, $httpConfigurator) {
		"ngInject";
		super($injector, dependencies);

		this.$httpConfigurator = $httpConfigurator;
		this.email = null;

	}

    $onSubmit() {
        this.$auth.$http({
            url: "/api/password/reset/",
            method: "POST",
            data: {email: this.email}
        }).then(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(5000)
                    .textContent(`Reset link sent to your email!`)
            );
            this.$state.go("auth.signin");
        }).catch(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(3000)
                    .textContent(`User with provided email not found`)
            );
        });
	}

}


// WEBPACK FOOTER //
// ./sources/components/auth/password/password.controller.js